import { render, staticRenderFns } from "./add-sub-account-modal.vue?vue&type=template&id=1e15383c&scoped=true&"
import script from "./add-sub-account-modal.vue?vue&type=script&lang=js&"
export * from "./add-sub-account-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-sub-account-modal.vue?vue&type=style&index=0&id=1e15383c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e15383c",
  null
  
)

export default component.exports